import axios from "axios";
import { ResponseAPIModel } from "../../../../setup/models/ResponseAPIModel";
import { FindTransactionModel, TransactionSummaryReportModel } from "../models";
import { RefundPaymentModel, TransactionModel, VoidPaymentModel } from "../models/TransactionModel";

const API_URL = process.env.REACT_APP_API_URL || '/api'

export const FIND_TRANSACTION_URL = `${API_URL}/Report/transaction/find`;
export const GET_TRANSACTION_URL = `${API_URL}/Report/transaction/status`;
export const REFUND_PAYMENT_URL = `${API_URL}/payment/refund`;
export const VOID_PAYMENT_URL = `${API_URL}/payment/void`;
export const POSTAUTH_PAYMENT_URL = `${API_URL}/payment/postauth`;

export const findTransactions = (findModel: FindTransactionModel) => {
  return axios.post<ResponseAPIModel<TransactionSummaryReportModel>>(FIND_TRANSACTION_URL, findModel);
}

export function getTransactionDetails(paymentId: string) {
  return axios.post<ResponseAPIModel<TransactionModel>>(GET_TRANSACTION_URL, { payment_id: paymentId });
}

export function refundTransaction(paymentId: string, amount: number) {
  return axios.post<ResponseAPIModel<RefundPaymentModel>>(REFUND_PAYMENT_URL, { payment_id: paymentId, amount: amount });
}

export function voidTransaction(paymentId: string) {
  return axios.post<ResponseAPIModel<VoidPaymentModel>>(VOID_PAYMENT_URL, { payment_id: paymentId });
}

export function postAuthTransaction(paymentId: string, amount: number) {
  return axios.post<ResponseAPIModel<RefundPaymentModel>>(POSTAUTH_PAYMENT_URL, { payment_id: paymentId, amount: amount });
}
